define.alias("shared/components/shared/button/media-uploader", "media/components/shared/button/media-uploader");